import { render } from "./DettaglioProdotto.vue?vue&type=template&id=3df81b21&scoped=true"
import script from "./DettaglioProdotto.vue?vue&type=script&lang=js"
export * from "./DettaglioProdotto.vue?vue&type=script&lang=js"

import "./DettaglioProdotto.vue?vue&type=style&index=0&id=3df81b21&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df81b21"]])

export default __exports__